import OnboardingInterestsPage from './OnboardingInterestsPage'

export default OnboardingInterestsPage
